import { useEffect, useMemo } from 'react';
import { useRouteMatch, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useRouting } from '@alycecom/hooks';
import { flip, includes, none } from 'ramda';

import { getIsEmptyGiftFlow } from '../store/giftFlow/giftFlow.selectors';

const EXCLUDED_ROUTES = ['redeem', 'decline', 'finish-info', 'thank-you'];

/**
 * If we don't have data in the redux store send user to the RLP page.
 */
export default (): void => {
  const { url: parentUrl } = useRouteMatch();
  const { pathname } = useLocation();
  const isEmptyGiftFlow = useSelector(getIsEmptyGiftFlow);
  const go = useRouting();

  const shouldGoBack = useMemo(() => {
    const checkRoute = flip(includes)(pathname);
    // TODO: Find how to use types.
    // @ts-ignore
    return isEmptyGiftFlow && pathname !== parentUrl && none(checkRoute)(EXCLUDED_ROUTES);
  }, [pathname, parentUrl, isEmptyGiftFlow]);

  useEffect(() => {
    if (isEmptyGiftFlow && shouldGoBack) {
      go(parentUrl);
    }
  }, [isEmptyGiftFlow, shouldGoBack, parentUrl, go]);
};
